import React from 'react';
import PropTypes from 'prop-types';
import { Image, CTA } from '../../';

import styles from './index.module.scss';

const BaseImageCard = ({ data, disableLink, ...other }) => {
	if (!data) return null;

	const renderImageCard = (data) => (
		<div
			className={styles.imageCard}
			{...other}
		>
			{data.image?.[0] && (
				<Image
					data={data.image[0]}
					className={styles.imageCard_Image}
				/>
			)}
			{data.heading && (
				<div
					className={`${styles.imageCard_Heading} bg-white p-4 font-semibold leading-tight text-black`}
					dangerouslySetInnerHTML={{ __html: data.heading }}
				/>
			)}
		</div>
	);

	return (
		<>
			{!disableLink && data.ctas?.[0] && (
				<CTA
					data={data.ctas[0]}
					renderAs='link'
				>
					{renderImageCard(data)}
				</CTA>
			)}
			{(disableLink || !data.ctas?.[0]) && renderImageCard(data)}
		</>
	);
};

BaseImageCard.propTypes = {
	data: PropTypes.object,
	disableLink: PropTypes.bool,
};

export default BaseImageCard;
